import React, { useEffect, useState } from 'react';
import Styles from './BensServicosPJParcelaFacilitada.css';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import RedButton from '@/components/atoms/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import { isBrowser, isMobile } from '@/utils/browser';

function BensServicosPJParcelaFacilitada() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  const updateCarouselContainer = () => {
    const el = document.querySelector('#container-parcela .parcela-facilitada-textos-carrossel');

    if (isMobile()) {
      el.style.width = '100%';
      return;
    }

    const ref = document.getElementById('container-reference');

    if (ref) {
      const style = window.getComputedStyle(ref);
      const m = style.marginLeft;
      try {
        el.style.width = `calc(100% - ${m})`;
      } catch (error) {
        console.log(error);
      }
    }
    return null;
  };

  useEffect(() => {
    if (!isBrowser()) return;

    window.addEventListener('resize', updateCarouselContainer);

    updateCarouselContainer();
    return () => {
      updateCarouselContainer();
      window.removeEventListener('resize', updateCarouselContainer);
    };
  }, []);

  return (
    <>
      <section id="bens-servicos-pj-parcela-facilitada">
        <ContainerHome24 id="container-parcela">
          <div className="parcela-facilitada-textos-carrossel">
            <div className="parcela-facilitada-textos">
              <h2 className="parcela-facilitada-textos-titulo">
                Impulsione o crescimento da sua empresa
              </h2>
              <p className="parcela-facilitada-textos-conteudo">
                Invista no crescimento da sua empresa com nossas soluções de parcelamento no boleto
                ou débito automático. Oferecemos taxas competitivas e prazos estendidos para atender
                às suas necessidades e transformar seus projetos em realidade!
                <br />
                <br />
                Confira tudo que você pode parcelar com a gente:
                <br />
                <ul>
                  <li>Tecnologia</li>
                  <li>Equipamentos médicos</li>
                  <li>Energia solar</li>
                </ul>
              </p>
            </div>
            <div className="parcela-facilitada-carrossel">
              {/* Radio escondido para "desvirar" os cards */}
              <input type="radio" name="flip-card" id="none" className="flip-toggle" hidden />
              <CustomEmblaCarouselHome24
                enableBullets
                detectBulletCount
                enableMobileArrows
                enablePrevArrow
                wheelGestures
              >
                {({ className }) => (
                  <>
                    {/* CARD 1 */}
                    <div className={`parcela-facilitada-carrossel-slide ${className}`}>
                      <label className="flip-card">
                        <input type="radio" name="flip-card" className="flip-toggle" />
                        <div className="flip-card-inner">
                          <div className="flip-card-front parcela-facilitada-carrossel-card">
                            <p className="parcela-facilitada-carrossel-slide-titulo">Tecnologia</p>
                            {width <= 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/tecnologia.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/tecnologia.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/tecnologia.png"
                                  alt="Ambiente corporativo com servidores e computadores, representando soluções da Santander Financiamentos para empresas de tecnologia, como crédito para pequenas empresas, financiamento pessoal, crédito online e bens e serviços parcelados."
                                />
                              </picture>
                            )}
                            {width > 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/tecnologia-desk.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/tecnologia-desk.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/tecnologia-desk.png"
                                  alt="Ambiente corporativo com servidores e computadores, representando soluções da Santander Financiamentos para empresas de tecnologia, como crédito para pequenas empresas, financiamento pessoal, crédito online e bens e serviços parcelados."
                                />
                              </picture>
                            )}
                            <p className="parcela-facilitada-carrossel-slide-link">Saiba mais</p>
                          </div>
                          <label
                            htmlFor="none"
                            className="flip-card-back parcela-facilitada-carrossel-card"
                          >
                            <p className="parcela-facilitada-carrossel-slide-titulo">Tecnologia</p>
                            <div className="flip-card-back-infos">
                              <img
                                src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/ic_close_card.svg"
                                alt=""
                                className="ic-close-card"
                              />
                              <p className="flip-card-back-infos-title">Realize os seus projetos</p>
                              <p className="flip-card-back-infos-text">
                                Atualize seu negócio com a Santander Financiamentos! Conte com mais
                                de 300 parceiros para financiar notebooks, servidores e outros
                                equipamentos de tecnologia.
                              </p>
                            </div>
                            <p className="parcela-facilitada-carrossel-slide-link flip-card-back-link">
                              Saiba mais
                            </p>
                          </label>
                        </div>
                      </label>
                    </div>

                    {/* CARD 2 */}
                    <div className={`parcela-facilitada-carrossel-slide ${className}`}>
                      <label className="flip-card">
                        <input type="radio" name="flip-card" className="flip-toggle" />
                        <div className="flip-card-inner">
                          <div className="flip-card-front parcela-facilitada-carrossel-card">
                            <p className="parcela-facilitada-carrossel-slide-titulo">
                              Equipamentos médicos
                            </p>
                            {width <= 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos.png"
                                  alt="Máquina de ressonância magnética em ambiente iluminado, representando acesso a bens e serviços parcelados com Santander Financiamentos para empresas."
                                />
                              </picture>
                            )}
                            {width > 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos-desk.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos-desk.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos-desk.png"
                                  alt="Máquina de ressonância magnética em ambiente iluminado, representando acesso a bens e serviços parcelados com Santander Financiamentos para empresas."
                                />
                              </picture>
                            )}
                            <p className="parcela-facilitada-carrossel-slide-link">Saiba mais</p>
                          </div>
                          <label
                            htmlFor="none"
                            className="flip-card-back parcela-facilitada-carrossel-card"
                          >
                            <p className="parcela-facilitada-carrossel-slide-titulo">
                              Equipamentos médicos
                            </p>
                            <div className="flip-card-back-infos">
                              <img
                                src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/ic_close_card.svg"
                                alt=""
                                className="ic-close-card"
                              />
                              <p className="flip-card-back-infos-title">Seu consultório completo</p>
                              <p className="flip-card-back-infos-text">
                                A Santander Financiamentos te ajuda a equipar seu espaço. São mais
                                de 450 parceiros para encontrar os equipamentos médicos que precisa
                                para seu consultório.
                              </p>
                            </div>
                            <p className="parcela-facilitada-carrossel-slide-link flip-card-back-link">
                              Saiba mais
                            </p>
                          </label>
                        </div>
                      </label>
                    </div>

                    {/* CARD 3 */}
                    <div className={`parcela-facilitada-carrossel-slide ${className}`}>
                      <label className="flip-card">
                        <input type="radio" name="flip-card" className="flip-toggle" />
                        <div className="flip-card-inner">
                          <div className="flip-card-front parcela-facilitada-carrossel-card">
                            <p className="parcela-facilitada-carrossel-slide-titulo">
                              Energia solar
                            </p>
                            {width <= 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/energia-solar.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/energia-solar.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/energia-solar.png"
                                  alt="Profissional instalando painéis solares em telhado, ilustrando soluções da Santander Financiamentos para empresas, como crédito para pequenas empresas, empréstimo empresarial e bens e serviços parcelados."
                                />
                              </picture>
                            )}
                            {width > 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/energia-solar-desk.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/energia-solar-desk.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/energia-solar-desk.png"
                                  alt="Profissional instalando painéis solares em telhado, ilustrando soluções da Santander Financiamentos para empresas, como crédito para pequenas empresas, empréstimo empresarial e bens e serviços parcelados."
                                />
                              </picture>
                            )}
                            <p className="parcela-facilitada-carrossel-slide-link">Saiba mais</p>
                          </div>
                          <label
                            htmlFor="none"
                            className="flip-card-back parcela-facilitada-carrossel-card"
                          >
                            <p className="parcela-facilitada-carrossel-slide-titulo">
                              Energia solar
                            </p>
                            <div className="flip-card-back-infos">
                              <img
                                src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/ic_close_card.svg"
                                alt=""
                                className="ic-close-card"
                              />
                              <p className="flip-card-back-infos-title">
                                Sustentabilidade e economia
                              </p>
                              <p className="flip-card-back-infos-text">
                                Energia solar para sua empresa: menos custos, mais benefícios.
                                Financie com parcelas estendidas, reduza despesas mensais e tenha
                                créditos na conta de luz.
                              </p>
                            </div>
                            <p className="parcela-facilitada-carrossel-slide-link flip-card-back-link">
                              Saiba mais
                            </p>
                          </label>
                        </div>
                      </label>
                    </div>
                  </>
                )}
              </CustomEmblaCarouselHome24>
            </div>
          </div>
        </ContainerHome24>
        <ContainerHome24 id="container-reference">
          <div className="parcela-facilitada-numbers">
            <div className="parcela-facilitada-numbers-cards">
              <div className="parcela-facilitada-numbers-card">
                <p className="numbers-card-number">
                  <b>+</b>800 mil
                </p>
                <p className="numbers-card-text">financiamentos por ano</p>
              </div>
              <div className="parcela-facilitada-numbers-card">
                <p className="numbers-card-number">
                  <b>+</b>34 mil
                </p>
                <p className="numbers-card-text">lojas parceiras</p>
              </div>
              <div className="parcela-facilitada-numbers-card">
                <p className="numbers-card-number">
                  <b>+</b>60 anos
                </p>
                <p className="numbers-card-text">de experiência</p>
              </div>
            </div>
            <RedButton href="#bens-servicos-busca-loja" className="btn-lojas-parceiras">
              Ver lojas parceiras
            </RedButton>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default BensServicosPJParcelaFacilitada;
